var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0767 5.21993C11.4183 4.39863 12.5817 4.39864 12.9233 5.21993L14.146 8.15952C14.29 8.50576 14.6156 8.74233 14.9894 8.77229L18.1629 9.02671C19.0496 9.0978 19.4091 10.2043 18.7336 10.783L16.3157 12.8542C16.0309 13.0981 15.9065 13.4809 15.9935 13.8456L16.7322 16.9425C16.9386 17.8077 15.9973 18.4916 15.2382 18.0279L12.5213 16.3684C12.2012 16.1729 11.7988 16.1729 11.4787 16.3684L8.76175 18.0279C8.00266 18.4916 7.0614 17.8077 7.26779 16.9425L8.0065 13.8456C8.09351 13.4809 7.96914 13.0981 7.68435 12.8542L5.26645 10.783C4.59091 10.2043 4.95044 9.0978 5.83709 9.02671L9.01063 8.77229C9.38442 8.74233 9.71003 8.50576 9.85403 8.15952L11.0767 5.21993Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsActive);
export default __webpack_public_path__ + "static/media/points-active.1e67787607a890f2acf61d43fb0e25b7.svg";
export { ForwardRef as ReactComponent };